import React from "react";

/**
 * Small, unobtrusive "Made with Mindmap.so" attribution shown in the corner of
 * the chrome-less embed. It is the product's organic growth channel from every
 * embedded mindmap, so it is visible but tasteful — and it ALWAYS opens the app
 * in a new tab (`target="_blank" rel="noopener"`) so a click can never navigate
 * the host page (Notion, Confluence, a blog) that frames us.
 */
export const MadeWithBadge: React.FC = () => {
  return (
    <a
      href="/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Made with Mindmap.so — open the app in a new tab"
      style={{
        position: "absolute",
        bottom: "0.6rem",
        right: "0.6rem",
        zIndex: 6,
        display: "inline-flex",
        alignItems: "center",
        gap: "0.35rem",
        padding: "0.3rem 0.6rem",
        borderRadius: "999px",
        background: "var(--island-bg-color, rgba(255,255,255,0.92))",
        color: "#6965db",
        fontWeight: 600,
        fontSize: "0.72rem",
        lineHeight: 1,
        textDecoration: "none",
        boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
        border: "1px solid var(--default-border-color, #e5e5ea)",
      }}
    >
      <span aria-hidden>✦</span>
      Made with Mindmap.so
    </a>
  );
};

export default MadeWithBadge;
